module.exports = __webpack_public_path__ + "img/safsal_yes.57e84577.png";